<script>
import player from './player'
import configuratorMenu from './configurator-menu'
import designSummary from './design-summary'
import infoDialog from './info-dialog'
import modelPicker from './model-picker'
import cardCommercial from './card-commercial'
import store from '../store'

export default {
  name: 'configurator',
  components: {
    configuratorMenu,
    player,
    designSummary,
    infoDialog,
    cardCommercial,
    modelPicker
  },
  data: function () {
    return {
      showDialog: false,
      dataParsed: false,
      menuToggleInitial: 'close',
      menuToggleFinal: 'brush',
      windowWidth: 0,
      windowHeight: 0
    }
  },
  computed: {
    menuVisible () {
      let modelState = store.getters['model/getState']
      return modelState.menuVisible
    },
    currentScene () {
      let currentScene = store.getters['scenes/getCurrentScene']
      return currentScene
    },
    ui () {
      return store.getters['ui/getState'].ui
    }
  },
  created: function () {
    store.dispatch('ui/fetchData')
    store.dispatch('scenes/fetchData').then(() => {
      const scenes = store.getters['scenes/getState']
      if (scenes.length > 1) {
        // If we want to show the model loader first
        this.dataParsed = true
        store.commit('model/setProperty', {property: 'modelPicker', value: true})
      }
      if (scenes.length === 1) {
        // If we want to load a model first
        let scene = store.getters['scenes/getScene'](scenes[0].sceneuid)
        store.dispatch('scenes/setCurrentScene', {scene: scene})
        this.parseProjectData(scene)
        this.dataParsed = true
      }
    })
  },
  methods: {
    loadScene (sceneuid) {
      let scene = store.getters['scenes/getScene'](sceneuid)
      store.dispatch('scenes/setCurrentScene', {scene: scene}).then(() => {
        store.dispatch('player/fetchData', {scene: scene}).then(() => {
          // build the menu once the data has been loaded
          this.parseProjectData(scene).then(() => {
            this.dataParsed = true
            player.methods.loadScene(sceneuid)
          })
        })
      })
    },
    async parseProjectData (currentScene) {
      store.dispatch('environment/fetchData')
      store.dispatch('background/fetchData')
      store.dispatch('postprocessing/fetchData')
      store.dispatch('liquid/fetchData', {scene: currentScene})
      store.dispatch('materialList/fetchData', {scene: currentScene})
      store.dispatch('visibilitySingleList/fetchData', {scene: currentScene})
      store.dispatch('visibilityGroupList/fetchData', {scene: currentScene})
      store.dispatch('viewsList/fetchData')
      store.dispatch('environmenttexturesList/fetchData', {sceneuid: currentScene.sceneuid})
      store.dispatch('statesList/fetchData').then(() => {
        let state = store.getters['statesList/getState']
        if (state.states !== undefined) {
          for (let opt of state.states) {
            store.commit('statesList/recurseBasedOn', opt)
          }
        }
      })
    },
    toggleMenu () {
      let modelState = store.getters['model/getState']
      store.commit('model/setProperty', {property: 'menuVisible', value: !modelState.menuVisible})
    },
    showInfoDialog () {
      store.commit('model/setProperty', {property: 'infoDialog', value: true})
    },
    getWindowWidth (event) {
      this.windowWidth = document.documentElement.clientWidth
    },
    getWindowHeight (event) {
      this.windowHeight = document.documentElement.clientHeight
    }
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getWindowWidth)
    window.removeEventListener('resize', this.getWindowHeight)
  },
  mounted () {
    this.$nextTick(function () {
      window.addEventListener('resize', this.getWindowWidth)
      window.addEventListener('resize', this.getWindowHeight)

      this.getWindowWidth()
      this.getWindowHeight()
    })
  }
}
</script>

<template>
<div class="configurator" ref="configurator">
  <!-- Popups -->
  <designSummary v-bind:header="currentScene.header" v-bind:scenetitle="currentScene.scenetitle" v-bind:subheader="currentScene.subheader"/>
  <infoDialog v-bind:header="currentScene.header"/>
  <modelPicker/>

  <md-app>
    <md-app-toolbar class="md-primary md-medium" md-elevation="5">
      <md-speed-dial md-event="click" md-direction="bottom" v-if="windowWidth < 600" >
        <md-speed-dial-target class="md-accent" @click="toggleMenu">
          <md-icon class="md-morph-initial">{{menuToggleInitial}}</md-icon>
          <md-icon class="md-morph-final">{{menuToggleFinal}}</md-icon>
        </md-speed-dial-target>
      </md-speed-dial>

      <div style="flex: 1">
        <div class="md-headline">{{currentScene.scenetitle}}</div>
        <div v-if="windowWidth >= 600" class="md-subheading">{{currentScene.header}}</div>
      </div>

      <div v-if="ui.infopanel === true">
        <md-button v-if="windowWidth >= 600" class="md-raised md-accent" @click="showInfoDialog">
          <md-icon>info</md-icon>
          Info
        </md-button>
        <md-button v-else class="md-icon-button md-raised md-accent" @click="showInfoDialog">
          <md-icon>info</md-icon>
        </md-button>
      </div>
    </md-app-toolbar>

    <md-app-drawer class="sidebar md-layout" :md-active.sync="menuVisible" md-permanent="clipped">
      <configuratorMenu class="sidebar"/>
      <div v-if="ui.contactcard === true" class="brandingcontainer md-layout md-alignment-bottom-right">
        <md-content class="md-layout-item md-elevation-16">
          <cardCommercial/>
        </md-content>
      </div>
    </md-app-drawer>

    <md-app-content>
      <player v-if="dataParsed"/>
    </md-app-content>
  </md-app>
</div>
</template>

<style lang="scss" scoped>
  .md-app-content {
    padding: 0px;
  }
  .md-app {
    min-height: 100vh;
    max-height: 100vh;
  }
  .sidebar {
    width: 280px;
    max-width: calc(100vw - 100px);
    min-width: 200px;
  }
  .md-subheading {
    margin-left: 8px;
  }
  .md-headline {
    margin-left: 8px;
  }
.brandingcontainer {
    width: 100%;
}
</style>
